module.exports = __webpack_public_path__ + "img/women_on_beach_3.982971bb.jpg";